import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import './AddCharityModal.scss';
import { SSJBeaconInputField } from '../../Shared/Beacon/Registry';
import {
  SSJBeaconButton,
  SSJBeaconDropdown,
} from '../../Shared/Beacon/Registry';
import {
  ADD_CHARITY_MODAL,
  DELIVERY_MAIL_CHECK_TO_CHARITY,
} from '../../../settings/settings';
import { AddCharity } from '../../../redux/modules/qcd/qcd.module';
import {
  ADDRESS_REGEX,
  CITY_REGEX,
  errorMessages,
  ZIP_REGEX,
  ZIPEXT_REGEX,
} from '../../CollegeDistribute/CollegeDistributeSteps/Validations';

const us_states_abbr = [
  { label: 'AL', value: 'Alabama (AL)' },
  { label: 'AK', value: 'Alaska (AK)' },
  { label: 'AS', value: 'American Samoa (AS)' },
  { label: 'AZ', value: 'Arizona (AZ)' },
  { label: 'AR', value: 'Arkansas (AR)' },
  { label: 'CA', value: 'California (CA)' },
  { label: 'CO', value: 'Colorado (CO)' },
  { label: 'CT', value: 'Connecticut (CT)' },
  { label: 'DE', value: 'Delaware (DE)' },
  { label: 'DC', value: 'District Of Columbia (DC)' },
  { label: 'FM', value: 'Federated States of Micronesia (FM)' },
  { label: 'FL', value: 'Florida (FL)' },
  { label: 'GA', value: 'Georgia (GA)' },
  { label: 'GU', value: 'Guam (GU)' },
  { label: 'HI', value: 'Hawaii (HI)' },
  { label: 'ID', value: 'Idaho (ID)' },
  { label: 'IL', value: 'Illinois (IL)' },
  { label: 'IN', value: 'Indiana (IN)' },
  { label: 'IA', value: 'Iowa (IA)' },
  { label: 'KS', value: 'Kansas (KS)' },
  { label: 'KY', value: 'Kentucky (KY)' },
  { label: 'LA', value: 'Louisiana (LA)' },
  { label: 'MH', value: 'Marshall Islands (MH)' },
  { label: 'ME', value: 'Maine (ME)' },
  { label: 'MD', value: 'Maryland (MD)' },
  { label: 'MA', value: 'Massachusetts (MA)' },
  { label: 'MI', value: 'Michigan (MI)' },
  { label: 'MN', value: 'Minnesota (MN)' },
  { label: 'MS', value: 'Mississippi (MS)' },
  { label: 'MO', value: 'Missouri (MO)' },
  { label: 'MT', value: 'Montana (MT)' },
  { label: 'NE', value: 'Nebraska (NE)' },
  { label: 'NV', value: 'Nevada (NV)' },
  { label: 'NH', value: 'New Hampshire (NH)' },
  { label: 'NJ', value: 'New Jersey (NJ)' },
  { label: 'NM', value: 'New Mexico (NM)' },
  { label: 'NY', value: 'New York (NY)' },
  { label: 'NC', value: 'North Carolina (NC)' },
  { label: 'ND', value: 'North Dakota (ND)' },
  { label: 'MP', value: 'Northern Mariana Islands (MP)' },
  { label: 'OH', value: 'Ohio (OH)' },
  { label: 'OK', value: 'Oklahoma (OK)' },
  { label: 'OR', value: 'Oregon (OR)' },
  { label: 'PW', value: 'Palau (PW)' },
  { label: 'PA', value: 'Pennsylvania (PA)' },
  { label: 'PR', value: 'Puerto Rico (PR)' },
  { label: 'RI', value: 'Rhode Island (RI)' },
  { label: 'SC', value: 'South Carolina (SC)' },
  { label: 'SD', value: 'South Dakota (SD)' },
  { label: 'TN', value: 'Tennessee (TN)' },
  { label: 'TX', value: 'Texas (TX)' },
  { label: 'VI', value: 'U.S. Virgin Islands (VI)' },
  { label: 'UT', value: 'Utah (UT)' },
  { label: 'VT', value: 'Vermont (VT)' },
  { label: 'VA', value: 'Virginia (VA)' },
  { label: 'WA', value: 'Washington (WA)' },
  { label: 'WV', value: 'West Virginia (WV)' },
  { label: 'WI', value: 'Wisconsin (WI)' },
  { label: 'WY', value: 'Wyoming (WY)' },
];

export const AddCharityModal = ({
  closeModal,
  existingCharityName = '',
  existingAttention = '',
  existingAddressLineOne = '',
  existingAddressLineTwo = '',
  existingCity = '',
  existingState = '',
  existingZip = '',
  existingZipExt = '',
  deliveryMethod = DELIVERY_MAIL_CHECK_TO_CHARITY,
  charityID = undefined,
  editMode = false,
}) => {
  const dispatch = useDispatch();
  const [charityName, setCharityName] = useState(existingCharityName);
  const [attention, setAttention] = useState(existingAttention);
  const [addressLineOne, setAddressLineOne] = useState(existingAddressLineOne);
  const [addressLineTwo, setAddressLineTwo] = useState(existingAddressLineTwo);
  const [city, setCity] = useState(existingCity);
  const [state, setState] = useState(existingState);
  const [zip, setZip] = useState(existingZip);
  const [zipExt, setZipExt] = useState(existingZipExt);

  const CHARITYNAME_REGEX =
    /^(([ ]*)|([ A-Za-z0-9\-_/.":,'&#()%`$+*=\\{}[\];&amp;]+))$/i;
  const ATTENTION_REGEX =
    /^(([ ]*)|([ A-Za-z0-9\-_/.":,'&#()%`$+*=\\{}[\];&amp;]+))$/i;
  const addButtonDisabled =
    deliveryMethod === DELIVERY_MAIL_CHECK_TO_CHARITY
      ? charityName === '' ||
        !CHARITYNAME_REGEX.test(charityName) ||
        addressLineOne === '' ||
        !ADDRESS_REGEX.test(addressLineOne) ||
        city === '' ||
        !CITY_REGEX.test(city) ||
        state === undefined ||
        state === '' ||
        zip === '' ||
        !ZIP_REGEX.test(zip) ||
        !ZIPEXT_REGEX.test(zipExt) ||
        !ATTENTION_REGEX.test(attention)
      : charityName === '' ||
        !CHARITYNAME_REGEX.test(charityName) ||
        !ATTENTION_REGEX.test(attention);

  const handleSubmit = (
    charityName,
    attention,
    addressLineOne,
    addressLineTwo,
    city,
    state,
    zip,
    zipExt,
    charityID
  ) => {
    const charityObj = {
      charityName,
      attention,
      addressLineOne,
      addressLineTwo,
      city,
      state,
      zip,
      zipExt,
      deliveryMethod,
      charityID,
    };
    dispatch(AddCharity(charityObj));
    closeModal(ADD_CHARITY_MODAL);
  };

  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <div className="add-charity-modal blocked_data">
        <div className="add-charity-modal-header">
          <h2>Enter Your Qualified Charity:</h2>
        </div>
        <div className="add-charity-modal-subheader">
          <p>
            Please{' '}
            <a
              className="contact-us"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.troweprice.com/personal-investing/help/contact/index.html"
            >
              contact us
            </a>{' '}
            if you need assistance.
          </p>
        </div>
        <div className="add-charity-modal-container">
          {/* Charity Name */}
          <SSJBeaconInputField
            className="input-boxes blocked_data"
            id="charity-name"
            type="text"
            label="Charity Name"
            hint="Limit 30 characters including spaces. If you need to abbreviate the name, please verify it with the charity first."
            value={charityName}
            name="charity-name"
            pattern={CHARITYNAME_REGEX}
            maxlength="30"
            required={true}
            onBeaconInput={(e) => {
              const { target } = e;
              document.getElementById(target.id).evaluateValidations();
              setCharityName(target.value);
            }}
            errorsMap={{
              required: errorMessages.CHARITY_NAME,
              noMatchPattern: errorMessages.INVALID_CHARITY_NAME,
            }}
          />
          {/* Attention (optional) */}
          <SSJBeaconInputField
            className="input-boxes blocked_data"
            id="attention"
            type="text"
            label="Attention (optional)"
            value={attention}
            name="attention"
            pattern={ATTENTION_REGEX}
            maxlength="30"
            required={false}
            onBeaconInput={(e) => {
              const { target } = e;
              document.getElementById(target.id).evaluateValidations();
              setAttention(target.value);
            }}
          />
          {deliveryMethod === DELIVERY_MAIL_CHECK_TO_CHARITY && (
            <div className="address-form">
              {/* Address 1 */}
              <SSJBeaconInputField
                className="input-boxes blocked_data"
                id="address-1"
                type="text"
                label="Address 1"
                value={addressLineOne}
                name="address-1"
                pattern={ADDRESS_REGEX}
                maxlength="30"
                required={true}
                onBeaconInput={(e) => {
                  const { target } = e;
                  document.getElementById(target.id).evaluateValidations();
                  setAddressLineOne(target.value);
                }}
                errorsMap={{
                  required: errorMessages.ADDRESS_LINE_ONE,
                  noMatchPattern: errorMessages.INVALID_ADDRESS_LINE_ONE,
                }}
              />
              {/* Address 2 (optional)  */}
              <SSJBeaconInputField
                className="input-boxes blocked_data"
                id="address-2"
                type="text"
                label="Address 2 (optional)"
                value={addressLineTwo}
                name="address-2"
                pattern={ADDRESS_REGEX}
                maxlength="30"
                required={false}
                onBeaconInput={(e) => {
                  const { target } = e;
                  document.getElementById(target.id).evaluateValidations();
                  setAddressLineTwo(target.value);
                }}
                errorsMap={{
                  required: errorMessages.ADDRESS_LINE_TWO,
                  noMatchPattern: errorMessages.INVALID_ADDRESS_LINE_TWO,
                }}
              />
              {/* City      State */}
              <div className={'addressRow blocked_data'}>
                <SSJBeaconInputField
                  id="city-name"
                  type="text"
                  label="City"
                  value={city}
                  name="city-name"
                  pattern={CITY_REGEX}
                  maxlength="20"
                  required={true}
                  onBeaconInput={(e) => {
                    const { target } = e;
                    document.getElementById(target.id).evaluateValidations();
                    setCity(target.value);
                  }}
                  errorsMap={{
                    required: errorMessages.CITY,
                    noMatchPattern: errorMessages.INVALID_CITY,
                  }}
                />
                <SSJBeaconDropdown
                  id="state-name"
                  name="state-name"
                  label="State"
                  value={state}
                  required={true}
                  placeholder={true}
                  onBeaconChange={(e) => {
                    setState(e.target.value);
                  }}
                  errorsMap={{
                    required: errorMessages.STATE,
                  }}
                >
                  {us_states_abbr.map((state, key) => (
                    <option key={key} value={state.value}>
                      {state.label}
                    </option>
                  ))}
                </SSJBeaconDropdown>
              </div>
              <div className={'addressRow zipRow blocked_data'}>
                {/* Zip Code (2 boxes)  */}
                <SSJBeaconInputField
                  id="zip-code-1"
                  type="text"
                  label="Zip Code"
                  value={zip}
                  name="zip-code-1"
                  pattern={ZIP_REGEX}
                  maxlength="5"
                  required={true}
                  onBeaconInput={(e) => {
                    const { target } = e;
                    document.getElementById(target.id).evaluateValidations();
                    setZip(target.value);
                  }}
                  errorsMap={{
                    required: errorMessages.ZIP,
                    noMatchPattern: errorMessages.INVALID_ZIP,
                  }}
                />
                <hr className="dash-line"></hr>
                <SSJBeaconInputField
                  id="zip-code-2"
                  type="text"
                  label="Zip Extension"
                  value={zipExt}
                  name="zip-code-2"
                  pattern={ZIPEXT_REGEX}
                  maxlength="4"
                  required={false}
                  onBeaconInput={(e) => {
                    const { target } = e;
                    document.getElementById(target.id).evaluateValidations();
                    setZipExt(target.value);
                  }}
                  errorsMap={{
                    noMatchPattern: errorMessages.INVALID_ZIP_EXT,
                  }}
                />
              </div>
            </div>
          )}
        </div>
        <div className="modal-buttons">
          <SSJBeaconButton
            id="add"
            label={editMode ? 'Update' : 'Add'}
            variant="primary"
            disabled={addButtonDisabled}
            buttonTarget=""
            onClick={() => {
              handleSubmit(
                charityName,
                attention,
                addressLineOne,
                addressLineTwo,
                city,
                state,
                zip,
                zipExt,
                charityID
              );
            }}
          />
          <SSJBeaconButton
            id="cancel"
            className="cancel"
            label="Cancel"
            variant="tertiary"
            disabled={false}
            onClick={() => closeModal(ADD_CHARITY_MODAL)}
          />
        </div>
      </div>
    </form>
  );
};

export default AddCharityModal;
